import { render, staticRenderFns } from "./DeleteModalComponent.vue?vue&type=template&id=7a2c0780&scoped=true&"
import script from "./DeleteModalComponent.vue?vue&type=script&lang=js&"
export * from "./DeleteModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModalComponent.vue?vue&type=style&index=0&id=7a2c0780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2c0780",
  null
  
)

export default component.exports